import React from 'react';
import { Link } from 'react-router-dom';
import { t, tBB } from '../../../../../../../../shared/components/l10n/l10n';
import { Button, Group, Dialog, Icon } from '@economic/taco';

import InformationSentIllustration from '../../../../assets/Information-sent.png';
import { SmartPayCustomerType } from '../../../../types';

interface Props {
    onDialogClose: () => void;
    refetchState?: () => void;
    inMarket?: boolean;
    email: string;
    customerType: SmartPayCustomerType;
}

const SuccessStep = ({ onDialogClose, refetchState, inMarket, email, customerType }: Props) => {
    const existingCustomer =
        customerType === SmartPayCustomerType.ExistingCustomerWithIntegration ||
        customerType === SmartPayCustomerType.ExistingCustomerWithoutIntegration;

    const onConfirmedClicked = () => {
        if (typeof refetchState === 'function') refetchState();
        if (typeof onDialogClose === 'function') onDialogClose();
    };

    return (
        <>
            <Dialog.Title>
                {existingCustomer ? (
                    <img src={InformationSentIllustration} alt="Smart Pay Success graphic" className="w-48 my-6 mx-auto" />
                ) : null}
                <div className="my-4">
                    {existingCustomer
                        ? t`SMARTPAY_ONBOARDING_MODAL_EXISTING_CUSTOMER_SUCCESS_TITLE`
                        : t`SMARTPAY_ONBOARDING_MODAL_SUCCESS_TITLE`}
                </div>
            </Dialog.Title>

            {existingCustomer ? (
                <div>
                    {t(`SMARTPAY_ONBOARDING_MODAL_EXISTING_CUSTOMER_SUCCESS_CONTENT`, {
                        SMARTPAY_LINK: (
                            <Link to="/accounting/bank/smartpay">{t`SMARTPAY_ONBOARDING_MODAL_EXISTING_CUSTOMER_SUCCESS_CONTENT_SMARTPAY_BUTTON`}</Link>
                        ),
                    })}
                </div>
            ) : (
                <div className="flex flex-col mt-9">
                    <span>{tBB(`SMARTPAY_ONBOARDING_MODAL_SUCCESS_PARAGRAPH_1`)}</span>
                    <div className="flex flex-col items-start m-10">
                        <span className="my-1">
                            <Icon name="circle-tick" className="mr-2 text-blue" />
                            {tBB('SMARTPAY_ONBOARDING_MODAL_SUCCESS_NEXT_STEPS_1')}
                        </span>
                        <span className="my-1">
                            <Icon name="circle-tick" className="mr-2 text-blue" />
                            {tBB('SMARTPAY_ONBOARDING_MODAL_SUCCESS_NEXT_STEPS_2')}
                        </span>
                        <span className="my-1">
                            <Icon name="circle-tick" className="mr-2 text-blue" />
                            {tBB('SMARTPAY_ONBOARDING_MODAL_SUCCESS_NEXT_STEPS_3')}
                        </span>
                    </div>
                    <span>
                        {tBB(`SMARTPAY_ONBOARDING_MODAL_SUCCESS_PARAGRAPH_2`, {
                            EMAIL: <strong>{email}</strong>,
                        })}
                    </span>
                </div>
            )}

            <Dialog.Footer>
                {inMarket ? (
                    <Group>
                        <Button onClick={onDialogClose}>{t`SMARTPAY_ONBOARDING_MODAL_CONSENT_CLOSE_BUTTON`}</Button>
                        <Button autoFocus appearance="primary" href={'/accounting/bank/smartpay'}>
                            {t`SMARTPAY_ONBOARDING_MODAL_SUCCESS_REDIRECT_BUTTON`}
                        </Button>
                    </Group>
                ) : (
                    <Button autoFocus appearance="primary" onClick={onConfirmedClicked}>
                        {t`SMARTPAY_ONBOARDING_MODAL_SUCCESS_CONFIRM_BUTTON`}
                    </Button>
                )}
            </Dialog.Footer>
        </>
    );
};

export default SuccessStep;
